import { Card, Group, Skeleton, Stack } from '@mantine/core'

export function AdCardSkeleton() {
  return (
    <Card shadow='sm' padding='lg' radius='md' withBorder>
      <Group align='flex-start' gap='lg'>
        <Skeleton height={175} width={300} radius='md' />

        <Stack style={{ flex: 1 }} gap='md'>
          <Group justify='space-between' align='center'>
            <Skeleton height={35} width={250} />
            <Group gap='xs'>
              <Skeleton height={32} width={80} radius='xl' />
              <Skeleton height={32} width={80} radius='xl' />
            </Group>
          </Group>

          <Stack>
            <Group gap='xs' align='center'>
              <Skeleton height={20} width={150} />
            </Group>
            <Group gap='xs' align='center'>
              <Skeleton height={20} width={170} />
            </Group>
            <Group gap='xs' align='center'>
              <Skeleton height={20} width={300} />
            </Group>
          </Stack>
        </Stack>
      </Group>
    </Card>
  )
}
